<template>
  <v-container fluid class="pa-0">
    <img
      src="@/assets/banner_privacy_portal.webp"
      class="banner"
      alt="Banner do Portal da Privacidade"
    >

    <v-row>
      <v-col cols="10" class="mx-auto mt-2">
        <h1 class="my-3 text-primary font-weight-bold">
          Portal da Privacidade
        </h1>
        <p style="font-size: large">
          Criado para facilitar o acesso aos principais documentos e serviços de
          privacidade e proteção de dados da CASSEMS, o Portal da Privacidade
          reúne políticas, manuais e informativos que guiam as boas práticas da
          empresa, além de comunicados e atualizações relevantes sobre o tema.
          Este espaço oferece ainda orientações claras sobre os direitos dos
          titulares de dados, destacando o compromisso com a transparência e o
          cumprimento da legislação vigente. Explore o portal para se informar e
          conhecer as iniciativas adotadas para garantir a segurança e a
          privacidade das informações.
        </p>
      </v-col>
    </v-row>

    <v-row class="container-blue">
      <v-col cols="10" class="mx-auto mb-3">
        <h1 class="my-3 font-weight-bold">
          Acesso Rápido
        </h1>
        <QuickAccess :items="quickAccess" />
      </v-col>
    </v-row>

    <v-row class="my-5">
      <v-col cols="10" class="mx-auto text-primary py-4 mb-6">
        <h1 class="mb-3">
          Categorias
        </h1>

        <div v-if="categories.length === 0" class="my-8 text-center">
          <h2>Nenhuma categoria encontrada.</h2>
        </div>

        <v-row v-else class="container-card">
          <v-col
            v-for="category in categories"
            :key="'category-' + category.id"
            class="card"
          >
            <img
              v-if="category.image"
              :src="category.image"
              style="border-radius: 5px"
              width="100%"
              height="200px"
            >
            <div v-else style="height: 200px" />
            <h2 class="my-4">
              {{ category.title }}
            </h2>

            <div style="flex-grow: 1" />

            <router-link
              class="custom-btn"
              :to="`privacy-portal-category/${category.id}`"
            >
              <div class="custom-btn-bg">
                <v-icon color="#173c93" size="25px">
                  mdi-arrow-right
                </v-icon>
              </div>
              <p class="custom-btn-text">
                Visualizar
              </p>
            </router-link>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        ref="latestPublications"
        class="bg-primary text-white"
        data-latest-publications
        cols="12"
      >
        <v-row>
          <v-col cols="10" class="mx-auto">
            <h1 class="my-3 font-weight-bold">
              Últimas publicações
            </h1>
            <div>
              <LatestPrivacyNews />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QuickAccess from "./QuickAccess.vue";
import LatestPrivacyNews from "./LatestPrivacyNews.vue";
import PrivacyPortalCategory from "../../services/privacy-portal-category";

export default {
  name: "PrivacyPortalHome",
  components: { QuickAccess, LatestPrivacyNews },
  data() {
    return {
      quickAccess: [
        {
          id: 1,
          text: "Consulte a Lei Geral de Proteção de Dados Pessoais na íntegra",
          link: "https://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm",
          newTab: true,
        },
        {
          id: 2,
          text: "Acesse nossa Política Interna de Privacidade e Proteção de Dados Pessoais",
          link: "/external/privacy-policy",
          newTab: false,
        },
        {
          id: 3,
          text: "Saiba quem é nosso Encarregado de Dados Pessoais",
          link: "/external/privacy-office",
          newTab: false,
        },
        {
          id: 4,
          text: "Exercite seus Direitos como Titular de Dados Pessoais",
          link: "https://cassems901351.app.privacycenter.cloud/#/?tab=DATA_SUBJECT_RIGHTS",
          newTab: true,
        },
        {
          id: 5,
          text: "Informe Incidentes ou Vazamento de Dados Pessoais",
          link: "/external/report-incident",
          newTab: false,
        },
      ],
      categories: [],
    };
  },
  async created() {
    this.categories = await PrivacyPortalCategory.findPrivacyCategories();
  },
  methods: {
    redirectToExternalPage() {
      return this.$route.name && this.$route.name.startsWith("external");
    },
  },
};
</script>

<style scoped>
.banner {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.container-blue {
  background-color: #173c94;
  color: white;
}

.custom-divider {
  background-color: #173c94;
  border-width: 1.5px;
}
</style>
